export const testCVV = (CVV, maxLength) => !!CVV && CVV.length === maxLength;
